module.exports = __webpack_public_path__ + "img/notification-bing.8bd56840.svg";